import React, { useState } from 'react';
import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import { LogIn, UserPlus, Mail, Lock, AlertCircle } from 'lucide-react';
import './Auth.css';

const Auth = ({ onAuthSuccess }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [showVerification, setShowVerification] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [cognitoUser, setCognitoUser] = useState(null);

  const userPool = new CognitoUserPool({
    UserPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
    ClientId: process.env.REACT_APP_COGNITO_CLIENT_ID,
  });

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const authenticationDetails = new AuthenticationDetails({
      Username: email,
      Password: password,
    });

    const user = new CognitoUser({
      Username: email,
      Pool: userPool,
    });

    user.authenticateUser(authenticationDetails, {
      onSuccess: (session) => {
        setLoading(false);
        onAuthSuccess(session);
      },
      onFailure: (err) => {
        setLoading(false);
        setError(err.message || 'Erro ao fazer login');
      },
    });
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (password !== confirmPassword) {
      setError('As senhas não coincidem');
      setLoading(false);
      return;
    }

    const attributeList = [
      {
        Name: 'email',
        Value: email,
      },
    ];

    userPool.signUp(email, password, attributeList, null, (err, result) => {
      setLoading(false);
      if (err) {
        setError(err.message || 'Erro ao criar conta');
        return;
      }
      setCognitoUser(result.user);
      setShowVerification(true);
    });
  };

  const handleVerification = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    cognitoUser.confirmRegistration(verificationCode, true, (err, result) => {
      setLoading(false);
      if (err) {
        setError(err.message || 'Código de verificação inválido');
        return;
      }
      setShowVerification(false);
      setIsLogin(true);
      setPassword('');
      setConfirmPassword('');
      setVerificationCode('');
    });
  };

  if (showVerification) {
    return (
      <div className="auth-container">
        <div className="auth-box">
          <div className="auth-header">
            <Mail size={48} />
            <h1>Verificar Email</h1>
            <p>Enviamos um código para {email}</p>
          </div>

          {error && (
            <div className="auth-error">
              <AlertCircle size={20} />
              <span>{error}</span>
            </div>
          )}

          <form onSubmit={handleVerification}>
            <div className="form-group">
              <label>Código de Verificação</label>
              <input
                type="text"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                placeholder="Digite o código de 6 dígitos"
                required
                maxLength={6}
              />
            </div>

            <button type="submit" className="auth-button" disabled={loading}>
              {loading ? 'Verificando...' : 'Verificar'}
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <div className="auth-box">
        <div className="auth-header">
          <LogIn size={48} />
          <h1>Market Cloud S3</h1>
          <p>Faça login para continuar</p>
        </div>

        {error && (
          <div className="auth-error">
            <AlertCircle size={20} />
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
            />
          </div>

          <div className="form-group">
            <label>Senha</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              required
              minLength={8}
            />
          </div>

          <button type="submit" className="auth-button" disabled={loading}>
            {loading ? 'Aguarde...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Auth;
